const takeLastElement = (fieldName: string) => {
  const elements = fieldName?.split(".");
  return elements[elements?.length - 1];
};
export { takeLastElement };
